module.exports = __webpack_public_path__ + "static/media/1021457.f0c627aa.jpg";